
































import "./review-list.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ReviewCard from "./review-card.vue";
import ReviewCopy from "./review-copy.vue";
import ReviewSetup from "./review-setup.vue";
import CardSimpleButton from "../../components/bio/card-simple-button.vue";
import DeleteReviewModal from "./delete-review-modal.vue";

export default Vue.extend({
  name: "ReviewList",
  components: {
    ReviewCard,
    ReviewCopy,
    ReviewSetup,
    CardSimpleButton,
    DeleteReviewModal,
  },
  props: {
    selectedMemberId: {
      type: Number,
      default: NaN,
      required: true,
    },
    personalReviewFilter: {
      type: String,
      default: "All Reviews",
      required: false,
    },
  },
  data() {
    return {
      showReviewCopy: false,
      showReviewSetup: false,
      showDelete: false,
      copyingReview: null,
      edittingReview: {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: null,
        description: null,
        members: [],
        hashTags: null,
        grantedPermissions: [],
        teamworkOption: NaN,
        editRole: NaN,
        calculationOption: NaN,
        gradingOption: NaN,
        parentRoleName: null,
        childRoleName: null,
        gradeModel: null,
        completed: false,
        teams: [],
      },
      archiveOrDeleteReview: null,
    };
  },
  computed: {
    ...mapState("session", ["user"]),
    personalReviewResults(): any {
      let groups = [];
      let allReviews = this.$store.state.review.myReviews;
      let reviews = allReviews || [];
      let hashTagFilter = null;

      if (this.selectedMemberId !== NaN) {
        reviews = reviews.filter(
          (review) =>
            (review.members && review.members.filter((member) => member.memberId === this.selectedMemberId).length > 0) ||
            (review.teams && review.teams.filter((reviewTeam) => reviewTeam.teamMembers && reviewTeam.teamMembers.filter((member) => member.memberId === this.selectedMemberId).length > 0).length > 0)
        );
      }

      let tags = [];
      if (this.personalReviewFilter && this.personalReviewFilter.startsWith("#")) {
        hashTagFilter = this.personalReviewFilter.replace("#", "");
        reviews = reviews.filter((review) => review.hashTagList && review.hashTagList.filter((tag) => tag.text === hashTagFilter).length > 0);

        tags = [hashTagFilter];
      } else {
        if (this.personalReviewFilter === "Completed Reviews") {
          reviews = reviews.filter((review) => review.completed === true);
        } else if (this.personalReviewFilter === "Active Reviews") {
          reviews = reviews.filter((review) => review.completed === false);
        }

        tags = this.getHashTags(reviews);
      }

      let noHashTagReviews = reviews.filter((review) => !review.hashTagList || review.hashTagList.length < 1);

      if (noHashTagReviews.length > 0) {
        groups.push({
          title: "No # Tags",
          reviews: noHashTagReviews,
        });
      }

      tags = tags.sort();

      tags.forEach((hashTag) => {
        let tagedReviews = reviews.filter((review) => review.hashTagList && review.hashTagList.filter((tag) => tag.text === hashTag).length > 0);

        if (tagedReviews.length > 0) {
          groups.push({
            title: hashTag,
            reviews: reviews.filter((review) => review.hashTagList && review.hashTagList.filter((tag) => tag.text === hashTag).length > 0),
          });
        }
      });

      if (groups.length == 0) {
        groups.push({
          title: "No # Tags",
          reviews: [],
        });
      }

      return groups;
    },
  },
  methods: {
    getHashTags(reviews) {
      let hashTags = [];
      reviews.forEach((review) => {
        hashTags = hashTags.concat(review.hashTagList.map((tag) => tag.text));
      });
      return [...new Set(hashTags)];
    },
    encodeName(hashTag, name) {
      return `${hashTag}--${name}`;
    },
    showReviewCreator() {
      let user = (this as any).user;
      this.edittingReview = {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: [],
        description: null,
        members: [{ memberId: user.id, memberName: user.nameName, memberEmailAddress: user.memberEmailAddress, memberAvatarImageUrl: user.memberAvatarImageUrl, role: 1, accepted: true }],
        hashTags: "",
        teamworkOption: 1,
        editRole: 1,
        calculationOption: 1,
        gradingOption: 1,
        parentRoleName: null,
        childRoleName: null,
        grantedPermissions: ["Bio.AssignParentRole", "Bio.AssignChildRole", "Bio.AssignAuthorRole", "Bio.AssignFan"],
        gradeModel: JSON.stringify([
          { name: "Green", color: "#5EA95E", from: 70 },
          { name: "Yellow", color: "#FFAC2B", from: 31 },
          { name: "Red", color: "#F06849", from: 0 },
        ]),
        completed: false,
        teams: [],
      };
      this.showReviewSetup = true;
    },
    handleCancelReviewCopy() {
      this.showReviewCopy = false;
    },
    handleCancelNewReview() {
      this.showReviewSetup = false;
    },
    markComplete(review, completed) {
      review.completed = completed;
      this.$store.dispatch("review/update", { data: review }).then(() => {});
    },
    showDeleteDialog(review) {
      this.archiveOrDeleteReview = review;
      this.showDelete = true;
    },
    handleDelete(action) {
      this.$store.dispatch("review/delete", { data: this.archiveOrDeleteReview }).then(() => {
        this.showDelete = false;
      });
    },
    handleRestore(review) {
      this.$store.dispatch("review/unarchive", { data: review }).then((response) => {});
    },
    handleOpenReviewEditor(review) {
      let startDate = review.startDate ? new Date(review.startDate) : null;
      let endDate = review.endDate ? new Date(review.endDate) : null;

      this.edittingReview = {
        id: review.id,
        name: review.name,
        scope: review.scope,
        timezoneOffset: review.timezoneOffset,
        timezoneName: review.timezoneName,
        timeline: [startDate, endDate],
        description: review.description,
        members: review.members,
        hashTags: review.hashTags,
        teamworkOption: review.teamworkOption,
        editRole: review.editRole,
        calculationOption: review.calculationOption,
        gradingOption: review.gradingOption,
        parentRoleName: review.parentRoleName,
        childRoleName: review.childRoleName,
        grantedPermissions: review.grantedPermissions,
        gradeModel: review.gradeModel,
        completed: review.completed,
        teams: review.teams,
      };

      this.showReviewSetup = true;
    },
    handleReviewCopy(review) {
      let startDate = review.startDate ? new Date(review.startDate) : null;
      let endDate = review.endDate ? new Date(review.endDate) : null;

      this.copyingReview = {
        id: review.id,
        name: review.name,
        scope: review.scope,
        timezoneOffset: review.timezoneOffset,
        timezoneName: review.timezoneName,
        timeline: [startDate, endDate],
        description: review.description,
        members: review.members,
        hashTags: review.hashTags,
        teamworkOption: review.teamworkOption,
        editRole: review.editRole,
        calculationOption: review.calculationOption,
        gradingOption: review.gradingOption,
        parentRoleName: review.parentRoleName,
        childRoleName: review.childRoleName,
        gradeModel: review.gradeModel,
      };

      this.showReviewCopy = true;
    },
  },
});
